var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUpArrowBoldCircle(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_27099",
    "data-name": "Group 27099",
    transform: "translate(-1000 -431)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_27093",
    "data-name": "Group 27093",
    transform: "translate(126 215)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_26913",
    "data-name": "Group 26913",
    transform: "translate(200)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_26909",
    "data-name": "Group 26909",
    transform: "translate(-893 -41)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_25269",
    "data-name": "Group 25269",
    transform: "translate(311 -862)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1564",
    "data-name": "Ellipse 1564",
    cx: 11.5,
    cy: 11.5,
    r: 11.5,
    transform: "translate(1256 1119)",
    fill: "#f2f2f4"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_26910",
    "data-name": "Group 26910"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_14123",
    "data-name": "Rectangle 14123",
    width: 11,
    height: 11,
    transform: "translate(680 222)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7369",
    "data-name": "Path 7369",
    d: "M729.664,1035.95a.455.455,0,0,1,.332.15l3.23,3.375a.46.46,0,0,1-.013.652.465.465,0,0,1-.319.129H731.2v3.535a.77.77,0,0,1-.768.768H728.9a.771.771,0,0,1-.768-.768v-3.535h-1.691a.462.462,0,0,1-.333-.78l3.228-3.375A.458.458,0,0,1,729.664,1035.95Z",
    transform: "translate(-43.976 -812.949)",
    fill: "#396"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpArrowBoldCircle);
export default __webpack_public_path__ + "static/media/up-arrow-bold_circle.5dd74f7beba991128452f3dbb5362d31.svg";
export { ForwardRef as ReactComponent };